import BaseService from './BaseService';

class FileService extends BaseService {

  constructor() {
    super();
    this.serviceUrl = "/api/rest/admin/files";
  }

  downloadFile(fileName) {
    const url = `/inbound/file?${fileName}`; 
    this.opencellAPI.callApi(url, true)
      .then((response) => {
        const name = (fileName || "").slice((fileName || "").lastIndexOf("/") + 1);
        const data = {source: response};
        const href = `data:application/pdf;base64,${data.source}`;
        const downloadLink = document.createElement('a');
        downloadLink.download =  name;
        downloadLink.href = href;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
      });
  }

  findFiles() {
    const url = this.serviceUrl + "?dir=" + DOCUMENT_PATH;
    return this.opencellAPI.callApi(url);
  }

  downloadPdf(fileName, base64Code) {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${base64Code}`;
    link.download = fileName;
    link.click();
    link.remove();
  }

}

const fileService = new FileService();
export default fileService;



// WEBPACK FOOTER //
// ./src/opencell/services/FileService.js